/** Mobile bottom-nav link: opens agenda in day view for today. */
export function agendaMobileNavHref(to: string): string {
    return to.includes("/agenda") ? `${to}?view=day` : to;
}

export function shouldFocusAgendaDayView(pathname: string, previousPathname: string, viewParam: string | null, mdUp: boolean): boolean {
    if (mdUp) {
return false;
}
    if (!pathname.includes("/agenda")) {
return false;
}
    if (viewParam === "day") {
return true;
}
    return !previousPathname.includes("/agenda");
}

export function initialAgendaCalendarView(mdUp: boolean): "month" | "week" | "day" {
    return mdUp ? "month" : "day";
}
